import React from "react";

export const TinyText = props =>
  <p className="text-faded small my-auto">
    {props.children}
  </p>;